import React, { useState, useEffect } from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { useLocation, useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import ghanaLogo from "../../assets/images/ghanaLOgoImage.jpg";
import LogoContainer from "./LogoContainer";
import DashboardHeader from "../../headers/DashboardHeader";

export default function ForGotPassword() {
  // ... [keep all your existing state and handlers] ...
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loginStates, setLoginStates] = useState({
    email: "",
    password: "",
    loading: false,
  });
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationEmail, setConfirmationEmail] = useState("");
  const location = useLocation();
  console.log(location, "locationlocationlocationlocation");
  const navigate = useNavigate();
  useEffect(() => {
    if (location.state?.accountCreated) {
      setShowConfirmation(true);
      setConfirmationEmail(location.state.email);
    }
  }, [location]);

  const handleChange = (e) => {
    setLoginStates({ ...loginStates, [e.target.name]: e.target.value });
  };
  const selectedMethod = location?.state?.selectedMethod;

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("/verification-otp", {
      state: { type: "forgot", selectedMethod: selectedMethod },
    });
  };

  return (
    <div className="header-container">
      <DashboardHeader />
      <div className="pageContainer">
        {/* Left Side - Full Logo Section */}
        <LogoContainer />

        {/* Right Side - Login Form */}
        <div style={styles.formContainer}>
          <div style={styles.formContent}>
            <h2 style={styles.signInTitle}>Forgot Password</h2>

            <form onSubmit={handleSubmit} style={styles.form}>
              {selectedMethod === "email" && (
                <div style={styles.formGroup}>
                  <label htmlFor="email" style={styles.label}>
                    Email *
                  </label>
                  <input
                    className="validated_input"
                    placeholder="Your registered email"
                    required
                    type="email"
                    id="email"
                    name="email"
                    value={loginStates.email}
                    onChange={handleChange}
                    style={styles.input}
                  />
                </div>
              )}

              {selectedMethod === "sms" && (
                <div style={styles.formGroup}>
                  <label htmlFor="phone" style={styles.label}>
                    Phone Number *
                  </label>
                  <input
                    className="validated_input"
                    placeholder="Enter your registered phone number"
                    required
                    type="text" // using text instead of number to prevent arrows
                    id="phone"
                    name="phone"
                    value={loginStates.phone}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        // allows only numbers
                        handleChange(e);
                      }
                    }}
                    style={styles.input}
                  />
                </div>
              )}

              <button
                type="submit"
                className="submit-button"
                style={styles.submitButton}
                disabled={loginStates.loading}
              >
                {loginStates.loading ? "Submitting..." : "Subimt"}
              </button>

              <div style={styles.signUpContainer}>
                <p style={styles.signUpText}>
                  Already have an account?{" "}
                  <a
                    className="sign-in-link"
                    href="/"
                    style={styles.signUpLink}
                  >
                    Sign in
                  </a>
                </p>
              </div>
            </form>
          </div>{" "}
        </div>
      </div>
    </div>
  );
}

const styles = {
  logoImage: {
    width: "100%",
    maxWidth: "500px",
    height: "auto",
    marginBottom: "30px",
    objectFit: "contain",
  },
  logoTitle: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "10px",
  },
  logoSubtitle: {
    fontSize: "1.5rem",
    color: "#555",
    fontWeight: "normal",
  },
  formContainer: {
    flex: 1.4, // Increased from 1 to make right side wider
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px",
    backgroundColor: "#f5f5f5",
  },
  formContent: {
    width: "100%",
    maxWidth: "400px",
  },
  signInTitle: {
    // fontSize: "1.8rem",
    // fontWeight: "bold",
    marginBottom: "30px",
    color: "#333",
  },
  form: {
    width: "100%",
  },
  formGroup: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "500",
    color: "#333",
  },
  input: {
    width: "100%",
    padding: "12px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "16px",
    boxSizing: "border-box",
  },
  visibilityToggle: {
    position: "absolute",
    right: "10px",
    top: "38px",
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#666",
  },
  forgotPasswordContainer: {
    textAlign: "right",
    marginBottom: "20px",
  },
  forgotPasswordLink: {
    color: "var(--portal-red-colr)",
    textDecoration: "none",
    fontSize: "14px",
  },
  submitButton: {
    width: "100%",
    padding: "14px",
    backgroundColor: "var(--portal-red-colr)",
    color: "white",
    border: "none",
    borderRadius: "4px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    marginBottom: "20px",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "var(--portal-red-colr)",
    },
  },
  signUpContainer: {
    textAlign: "center",
    marginTop: "20px",
  },
  signUpText: {
    color: "#555",
    fontSize: "14px",
    marginBottom: "0", // remove spacing between lines
  },

  signUpLink: {
    color: "var(--portal-red-colr)",
    textDecoration: "none",
    fontWeight: "bold",
    marginLeft: "5px",
  },
};
